import React, { Component } from 'react';

import Header from '../Header/Header';
import Footer from '../Footer/Footer';

import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
    footer: {
        background: "#BD0027 none repeat center top",
        textAlign: "center",
        padding: "0",
        width: "100%",
        postion: "absolute",
        left: 0,
        bottom: 0
    }
});

class Layout extends Component {
    render() {

        const { classes } = this.props;

        return (
            <Grid container spacing={16}
                direction="column"
                justify="center"
            >
                <Grid item xs={12}>
                    <Header />
                </Grid>
                <Grid item xs={12}>
                    {this.props.children}
                </Grid>
                <Grid item xs={12} className={classes.footer}>
                    <Footer />
                </Grid>
            </Grid>
        );
    }
}

export default withStyles(styles)(Layout);




// WEBPACK FOOTER //
// ./src/components/Layout/Layout.js